import { createTheme } from '@mui/material/styles';

// MUI does not export its default zIndex values, so read them off a bare theme.
const { modal } = createTheme().zIndex;

const zIndex = {
  // The pingu panel floats above modals. Its launcher bubble shares the layer:
  // the two are never rendered at the same time.
  pinguPanel: modal + 1,
  // Docked, the panel is part of the page, so dialogs opened from the page cover it.
  pinguDockedPanel: modal - 1,
  // Popovers opened from inside the panel have to clear it.
  pinguPopover: modal + 2,
};

export default zIndex;

declare module '@mui/material/styles' {
  interface ZIndex {
    pinguPanel: number;
    pinguDockedPanel: number;
    pinguPopover: number;
  }
}
